import { useState, useEffect, useRef,scrollContainerRefs,useMemo,useCallback  } from "react";
import { BsCurrencyDollar } from 'react-icons/bs'
import { GoPrimitiveDot } from 'react-icons/go'
import { IoIosMore } from 'react-icons/io'
import Grid from '@mui/material/Grid'
import Pusher from 'pusher-js';
import { SnackbarProvider, useSnackbar } from 'notistack';
import {Box,List,Typography,useTheme,Button} from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import LocalLibrarySharpIcon from '@mui/icons-material/LocalLibrarySharp';
import { DropDownListComponent} from '@syncfusion/ej2-react-dropdowns'
import { Doughnut, LineChart, SparkLine, Stacked } from '../components'
import { useStateContext } from '../contexts/ContextProvider'
import product9 from '../data/product9.jpg'
import { ModalComponentWithOutTags } from "../pages/modalComponentWithOutTags";
import CircleIcon from '@mui/icons-material/Circle';
import { ActionComponent } from "../pages/actionComponent";
import './orderlist.css'
import { ReactSession } from 'react-client-session';
import ReactLoading from "react-loading";
import {
    earningData,
    medicalproBranding,
    recentTransactions,
    weeklyStats,
    dropdownData,
    SparklineAreaData,
    econPieChartData,
    ecomPieChartData
}
from '../data/dummy'
import Swal from 'sweetalert2';


const DropDown = ({ currentMode }) => (
  <div className="px-2 py-1 w-28 rounded-md border-1 border-color">
    <DropDownListComponent
    id='time'
    fields={{ text:'Time' , value:'Id' }}
    style={{ border:'none', color: currentMode === 'Dark' && 'white'}}
    value='1'
    dataSource={dropdownData}
    popupHeight="220px"
    popupWidth='120px'
    />
  </div>
  )

  const OrderListWhitOutTags = ({ AudioPath, handlePlayPause , screenName ,handleUpdateAudio, pauseAudio , buttonRef ,audioRef ,handleUpdateModal ,userSetting,onData,currentTableData , modalOpenGloble , docketBump, SideMenuCls, currentP, post ,pageSize ,onPagenumber,toggleItemStatus,isCollapsedMenu }) => {

  const { currentColor, currentMode } = useStateContext()
  const [orderListing, setOrderListing] = useState(currentTableData);
  // console.log(currentTableData);
  
  const [currentEvents, setCurrentEvents] = useState([]);
  const [isClassNew, setClassNew] = useState(false);
  const [isClassPending, setClassPending] = useState(false);
  const [isClassComplete, setClassComplete] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [actionModal, setActionModal] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [addClass, setAddClass] = useState(false);
  const [dynamicClass, setDynamicClass] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedData, setSelectedData] = useState(null); // State to store selected data
  const [docketBumpId, setDocketBumpId] = useState();
  const [itemsId, setItemsId] = useState();
  const [itemsStatus, setItemsStatus] = useState();
  const [lastDocketStatus, setLastDocketStatus] = useState(false);
  const [allItemIds, setAllItemIds] = useState([]);
  const [sendClassModal, setSendClassModal] = useState('blue');
  const audioPlayer = useRef(null);
  const [currentDocketColor, setCurrentDocketColor] = useState(null);
 
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [isFos, setIsFos] = useState(null);
  const [fosStatus, setFosStatus] = useState(null);
  const [itemData, setItemData] = useState(null);
  

  const [modalOpenC, setModalOpenC] = useState(false);
  const [modalDataC, setModalDataC] = useState(null);
  const [modalDataH, setModalDataH] = useState(null);
  const [modalTextarea, setModalTextarea] = useState(null);
  
  const [modalDataA, setModalDataA] = useState([]);
   
  const groupingTags = ReactSession.get("groupingTags");
  const getSelectedtags = ReactSession.get("selectedtags");

  const [newOrderClass, setNewOrderClass] = useState(false);
  const [neutralOrderClass, setNeutralOrderClass] = useState(false);
  const [lateOrderClass, setLateOrderClass] = useState(false);
  const [timeoutIds, setTimeoutIds] = useState([]);
  const [colorClass, setColorClass] = useState('blue');

  const [isPlaying, setIsPlaying] = useState(false);

  const [currentItem, setCurrentItem] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
   //Visual Notification 1 for popup and 0 for toaster
  
   const [kdsTableMove, setKdsTableMove] = useState(ReactSession.get("kdsTableMove"));
   const [kdsItemVoid, setKdsItemVoid] = useState(ReactSession.get("kdsTableMove"));
   const [kdsNewOrdeMessageType, setKdsNewOrdeMessageType] = useState(ReactSession.get("kdsNewOrdeMessageType"));
   const [kdsNotification, setKdsNotification] = useState(ReactSession.get("kdsNotification"));
   
   const [kdsNewOrderAudio, setKdsNewOrderAudio] = useState(ReactSession.get("kdsNewOrderAudio"));
   const [kdsLateOrderAudio, setKdsLateOrderAudio] = useState(ReactSession.get("kdsLateOrderAudio"));
   const [kdsEmergencyOrderAudio, setKdsEmergencyOrderAudio] = useState(ReactSession.get("kdsEmergencyOrderAudio"));
   const [kdsCancelOrderAudio, setKdsCancelOrderAudio] = useState(ReactSession.get("kdsCancelOrderAudio"));

   const initialNewOrderAudioPath = useRef(null);
   const initialLateOrderAudioPath = useRef(null);
   const initialEmergencyOrderAudioPath = useRef(null);
   const initialCancelOrderAudioPath = useRef(null);
 
   const [kdsNewOrderAudioPath, setKdsNewOrderAudioPath] = useState();
   const [kdsLateOrderAudioPath, setKdsLateOrderAudioPath] = useState();
   const [kdsEmergencyOrderAudioPath, setKdsEmergencyOrderAudioPath] = useState();
   const [kdsCancelOrderAudioPath, setKdsCancelOrderAudioPath] = useState();
 
   const [kdsNewOrder, setKdsNewOrder] = useState(ReactSession.get("kdsNewOrder"));
   const [kdsLateOrder, setKdsLateOrder] = useState(ReactSession.get("kdsLateOrder"));
   const [kdsEmergencyOrder, setKdsEmergencyOrder] = useState(ReactSession.get("kdsEmergencyOrder"));
   const [kdsCancelOrder, setKdsCancelOrder] = useState(ReactSession.get("kdsCancelOrder"));
   
   const [kdsNotificationTimer, setKdsNotificationTimer] = useState(ReactSession.get("kdsNotificationTimer"));

  const [currentSession, setCurrentSession] = useState(
    sessionStorage.getItem('currentSession') || null
  );
  const [hasSoundPlayed, setHasSoundPlayed] = useState(
    sessionStorage.getItem('hasSoundPlayed') === 'true' || false
  );
  
  useEffect(() => {
    // Store the state in sessionStorage whenever it changes
    sessionStorage.setItem('currentSession', currentSession);
    sessionStorage.setItem('hasSoundPlayed', hasSoundPlayed.toString());
  }, [currentSession, hasSoundPlayed]);
   
  const [currentaudio, setCurrentaudio] = useState();
  const opensModal = (data, itemId, status ,lastDocket,classNameSend,getCommaSeperatedIds,isFos, fosStatus,itemData,colorNameKey) => {
    setModalData(data);
    setItemsId(itemId)
    setModalOpen(true);
    setItemsStatus(status)
    setLastDocketStatus(lastDocket);
    setAllItemIds(getCommaSeperatedIds)
    setSendClassModal(classNameSend)
    handleUpdateModal(true)
    setIsFos(isFos),
    setFosStatus(fosStatus)
    setItemData(itemData)
    setCurrentDocketColor(colorNameKey)
  };

  const closeModal = () => {
    setModalOpen(false);
    handleUpdateModal(false)
    
    
  };

  

  const handleUpdateListData = (updatedData,id) => {
   
    const updatedCollectData = updatedData.map((item) => {
      if (item.completed === true) {
        return item.id === id ? { ...item, completed: false, kitchen_status: 0 } : item;
      } else if (item.completed === false) {
        return item.id === id ? { ...item, completed: true, kitchen_status: 6 } : item;
      }
      return item;
    });
  
    setModalDataH(updatedCollectData);
  };

  const opensModalC = (data, dataA, dataH,classNameSend,textarea) => {

    setModalDataC(data);
    setModalDataH(dataH);
    setModalDataA([dataA]);
    setModalOpenC(true);
    setSendClassModal(classNameSend);
    handleUpdateModal(true);
    setModalTextarea(textarea)
   
  };
  

  const closeModalC = () => {
    setModalOpenC(false);
    handleUpdateModal(false)
   
  };


  
    const notifySuccess = () => toast('🦄 Wow so easy!', {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",

    });

 

    const handleShowAlert = () => {
      setShowAlert(true);
    };
    
    const handleCloseAlert = () => {
      setShowAlert(false);
    };
    

    const handleOpenModal = () => {
        setOpenModal(!openModal);
        
    }
    
    const handleOpenActionModal = (data) => {
        setSelectedData(data);
        setActionModal(!actionModal);
        
    }

  const handleDateClick = (selected) => {
    const title = prompt("Please enter a new title for your event");
    const calendarApi = selected.view.calendar;
    calendarApi.unselect();

    if (title) {
      calendarApi.addEvent({
        id: `${selected.dateStr}-${title}`,
        title,
        start: selected.startStr,
        end: selected.endStr,
        allDay: selected.allDay,
      });
    }
  };

  const [scrollPosition, setScrollPosition] = useState(0);
 
  const scrollContainerRefs = [useRef(null), useRef(null), useRef(null)];
  const scrollStep = 50; // Adjust scroll step as needed

 const handleScroll = (index, direction) => {
    const container = scrollContainerRefs[index].current;

    if (direction === 'up') {
      container.scrollTop -= scrollStep;
    } else if (direction === 'down') {
      container.scrollTop += scrollStep;
    }

    setScrollPosition(container.scrollTop);
  };

  const handleEventClick = (selected) => {
    if (
      window.confirm(
        `Are you sure you want to delete the event '${selected.event.title}'`
      )
    ) {
      selected.event.remove();
    }
  };

 

   useEffect(() => {
    // const timer = setTimeout(() => {
    //   setAddClass(true);
    //   setDynamicClass('animate-flicker');
    //   onData('animate-flicker');
    //   const timeout = setTimeout(() => {
    //     setAddClass(false);
    //     setDynamicClass('');
    //     onData('');
    //   }, 5000); // Remove the class after 5 seconds
    //   return () => clearTimeout(timeout); // Cleanup timeout
    // }, 4000); // Add the class after 10 minutes

    // return () => clearTimeout(timer); // Cleanup timer

  
  }, []);

  
   
  
   useEffect(() => {

    if (Array.isArray(userSetting) && userSetting.length > 0) {
      //console.log(userSetting[0]) // Will not run because arr is undefined
  
      var getPath = ReactSession.get("assetPath");
      
      var getSoundName = ReactSession.get("audioNotification");
      var getNameAudioNew = getSoundName.filter(
        (i) =>  {if(i.id === kdsNewOrderAudio) return i.id; }
  
      );
      var getNameAudioLate = getSoundName.filter(
        (i) =>  {if(i.id === kdsLateOrderAudio) return i.id; }
  
      );
      var getNameAudioEmergency = getSoundName.filter(
        (i) =>  {if(i.id === kdsEmergencyOrderAudio) return i.id; }
  
      );
      var getNameAudioCancel = getSoundName.filter(
        (i) =>  {if(i.id === kdsCancelOrderAudio) return i.id; }
  
      );

      

      setKdsNewOrderAudioPath( getPath+''+getNameAudioNew[0].name)
      setKdsLateOrderAudioPath(getPath+''+getNameAudioLate[0].name)
      setKdsEmergencyOrderAudioPath(getPath+''+getNameAudioEmergency[0].name)
      setKdsCancelOrderAudioPath(getPath+''+getNameAudioCancel[0].name)
      
      
       
     }
   

    if(Array.isArray(userSetting) && userSetting.length > 0){
    setColorClass(
        userSetting[0].kds_new_order_color
      );
     var forlatorderTime = userSetting[0].kds_default_preparation_time ;
     var forNeutralTime = userSetting[0].kds_default_preparation_time/2;
    }  
   
    // Set a timeout to add the class after 20 minutes
    const timeoutId1 = setTimeout(() => {
      setNewOrderClass(false)
      setNeutralOrderClass(false);
      setLateOrderClass(true);
      if(userSetting!== undefined){
      setColorClass(
         userSetting[0].kds_late_order_color
       )
      }

    }, forlatorderTime * 60 * 1000); // minutes in milliseconds

    
    const timeoutId2 = setTimeout(() => {
      setNewOrderClass(false)
      setNeutralOrderClass(true);
      setLateOrderClass(false);
      setColorClass('neutral-order');
      if(Array.isArray(userSetting) && userSetting.length > 0){
        setColorClass(
         userSetting[0].kds_neutral_order_color
      
      )
      }
      
    }, forNeutralTime * 60 * 1000); // minutes in milliseconds

    // Store the timeout IDs in the state
    setTimeoutIds([timeoutId1, timeoutId2]);

    // Clean up the timeout when the component unmounts or when the class is added
    return () => {
      timeoutIds.forEach(id => clearTimeout(id));
    };
  }, [userSetting]); 

  useEffect(() => {
    initialNewOrderAudioPath.current = kdsNewOrderAudioPath; // Update the mutable reference with the latest count value
  }, [kdsNewOrderAudioPath]);
  useEffect(() => {
    initialLateOrderAudioPath.current = kdsLateOrderAudioPath; // Update the mutable reference with the latest count value
  }, [kdsLateOrderAudioPath]);
  
  useEffect(() => {
    initialEmergencyOrderAudioPath.current = kdsEmergencyOrderAudioPath; // Update the mutable reference with the latest count value
  }, [kdsEmergencyOrderAudioPath]);

  useEffect(() => {
    initialCancelOrderAudioPath.current = kdsCancelOrderAudioPath; // Update the mutable reference with the latest count value
  }, [kdsCancelOrderAudioPath]);

   
  useEffect(() => {
    
  const interval = setInterval(() => {
    
    const currentTime = new Date();
    var hasLateOrder = false; // Flag to track if there is any late order
    // Find the current item based on the time
    const current = currentTableData.map(item => {
      const itemLateTime = new Date(item.forlatorderTime);
      const itemNeutralTime = new Date(item.forNeutralTime);
      const newTime =  new Date(item.formattedDateTimeNew);
      const neutralTime =  new Date(item.formattedDateTimeNeutral);
      const lateTime =  new Date(item.formattedDateTimeLate);
      
      if (currentTime <= newTime) {
        return { ...item, color: item.newOrderColor,
          tableitem: item.tableitem.map((items, index) => {
            let checkStatus = false;
            if(item.kitchen_status==6){
              checkStatus = true;
            }else{
              checkStatus = false;
            }
              // Modify the kitchen_status of the first item
              return {
                ...items,
                completed: checkStatus // Set to 1 for ready, or any other desired value
              };
           
          }),
         }; // Add the color key to the item and set its value
      } 
      else if (currentTime <= neutralTime) {
        return { ...item, color: item.neutralOrdercolor ,
           tableitem: item.tableitem.map((items, index) => {
          let checkStatus = false;
          if(items.kitchen_status==6){
            checkStatus = true;
          }else{
            checkStatus = false;
          }
            // Modify the kitchen_status of the first item
            return {
              ...items,
              completed: checkStatus // Set to 1 for ready, or any other desired value
            };
         
        }), }; // Add the color key to the item and set its value
      } else if (currentTime <= lateTime) {
        hasLateOrder = true; // Set the flag to true if there is a late order
        return { ...item, color: item.lateOrdercolor,
          tableitem: item.tableitem.map((items, index) => {
            let checkStatus = false;
            if(items.kitchen_status==6){
              checkStatus = true;
            }else{
              checkStatus = false;
            }
              // Modify the kitchen_status of the first item
              return {
                ...items,
                completed: checkStatus // Set to 1 for ready, or any other desired value
              };
           
          }),

         }; // Add the color key to the item and set its value
      }
      return { ...item, color: item.lateOrdercolor,
        tableitem: item.tableitem.map((items, index) => {
          let checkStatus = false;
          if(items.kitchen_status==6){
            checkStatus = true;
          }else{
            checkStatus = false;
          }
            // Modify the kitchen_status of the first item
            return {
              ...items,
              completed: checkStatus // Set to 1 for ready, or any other desired value
            };
         
        }),
       }; // Add the color key to the item and set its value
    });
   
    
    if ((hasLateOrder) && (!hasSoundPlayed) && (currentSession == null)) {
      console.log(hasLateOrder)
    console.log(!hasSoundPlayed)
    console.log(currentSession)
    console.log(kdsNotificationTimer)
    console.log(kdsLateOrderAudioPath)
      // Start a new session
      setCurrentSession(new Date().toString());
      // Play the sound here
      // playLateOrderSound();
      if(kdsLateOrder == 1){
        if(kdsNotificationTimer == 1){
          console.log(kdsLateOrderAudioPath)
          var audio = new Audio(kdsLateOrderAudioPath);
          setCurrentaudio(audio)
          setIsPlaying(true)
          audio.loop = true;
          audio.play()
        }else if(kdsNotificationTimer == 0){
          console.log(kdsLateOrderAudioPath)
          var audio = new Audio(kdsLateOrderAudioPath);
          setCurrentaudio(audio)
          audio.play()
        }
       
      }
     
      setHasSoundPlayed(true); // Set the flag to true after playing the sound
    }
    
    
    // Update the currentItem with the found item
    setCurrentItem(current);
    
    if (!hasLateOrder) {
      setHasSoundPlayed(false);
      setCurrentSession(null);
    }

  }, 3000); // Check every minute

  return () => clearInterval(interval); // Clean up the interval
}, [currentTableData]); // Trigger the effect when currentTableData changes


const pusherRef = useRef(null);
const channelRef = useRef(null);
const isPusherInitialized = useRef(false);

useEffect(() => {
  // Initialize Pusher only once
  if (!isPusherInitialized.current) {
    Pusher.logToConsole = true;

    pusherRef.current = new Pusher(ReactSession.get("pusher_app_key"), {
      cluster: ReactSession.get("pusher_app_cluster"),
      encrypted: true
    });

    isPusherInitialized.current = true;
  }

  // Check if notifications are enabled
  const isNotificationEnabled = kdsNotification === 1 || kdsNotification === 2 || kdsNotification === 3;

  // Subscribe to channel if notifications enabled and not already subscribed
  if (isNotificationEnabled && !channelRef.current) {
    channelRef.current = pusherRef.current.subscribe(ReactSession.get("pusher_app_channel"));
  }

  // Unsubscribe if notifications are disabled
  if (!isNotificationEnabled && channelRef.current) {
    channelRef.current.unbind_all();
    pusherRef.current.unsubscribe(ReactSession.get("pusher_app_channel"));
    channelRef.current = null;
    
    // Stop audio if playing
    if (currentaudio) {
      currentaudio.pause();
      setCurrentaudio(null);
      setIsPlaying(false);
    }
    return;
  }

  // If not subscribed, don't proceed
  if (!channelRef.current) return;

  const channel = channelRef.current;

  const handleNotification = (data) => {
    try {
      if (!data || !data.data) {
        console.warn('Invalid data structure received in handleNotification');
        return;
      }
  
      const tagIds = data.data.tag_ids || [];
      const selectedTags = Array.isArray(getSelectedtags) ? getSelectedtags : [];
      
      const hasMatchingTag = tagIds.length > 0 && selectedTags.length > 0 
        ? tagIds.some(tagId => selectedTags.includes(tagId))
        : false;
  
      if (hasMatchingTag) {
        if (currentaudio) {
          currentaudio.loop = false;
          currentaudio.pause();
          setCurrentaudio(null);
          setIsPlaying(false);
        }
        
        if (kdsNotification === 2 || kdsNotification === 3) {
          let audioPath;
  
          if (data.message_type === "new order" && kdsNewOrder === 1) {
            audioPath = initialNewOrderAudioPath.current;
          } else if (data.message_type === "item deleted" && kdsCancelOrder === 1) {
            audioPath = initialCancelOrderAudioPath.current;
          }
  
          if (audioPath) {
            const audio = new Audio(audioPath);
            setCurrentaudio(audio);
            setIsPlaying(true);
            handleUpdateAudio(audio);
            audio.loop = kdsNotificationTimer === 1;
            audio.play().catch(err => console.warn('Audio playback failed:', err));
          }
        }
  
        if (kdsNotification === 1 || kdsNotification === 3) {
          if (kdsNewOrdeMessageType === 0) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: data.message || 'New notification received',
              showConfirmButton: true,
              timer: 10000
            });
          } else if (kdsNewOrdeMessageType === 1) {
            enqueueSnackbar(data.message || 'New notification received', {
              variant: 'success',
              anchorOrigin: {
                vertical: 'top',
                horizontal: 'right',
              },
              autoHideDuration: 10000,
            });
          }
        }
      } else {
        if (kdsNotification === 1 || kdsNotification === 3) {
          if (kdsTableMove === 0) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: data.message || 'Table moved',
              showConfirmButton: true,
              timer: 10000
            });
          } else if (kdsTableMove === 1) {
            enqueueSnackbar(data.message || 'Table moved', {
              variant: 'success',
              anchorOrigin: {
                vertical: 'top',
                horizontal: 'right',
              },
              autoHideDuration: 10000,
            });
          }
        }
      }
    } catch (error) {
      console.error('Error in handleNotification:', error);
      enqueueSnackbar('Error processing notification', {
        variant: 'error',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        autoHideDuration: 5000,
      });
    }
  };

  const handleNotificationNew = (data) => {
    console.log(data);
    if (currentaudio) {
      currentaudio.loop = false;
      currentaudio.pause();
      setCurrentaudio(null);
      setIsPlaying(false);
    }

    if (kdsNotification === 2 || kdsNotification === 3) {
      let audioPath = initialNewOrderAudioPath.current;
      
      if (audioPath) {
        const audio = new Audio(audioPath);
        setCurrentaudio(audio);
        setIsPlaying(true);
        handleUpdateAudio(audio);
        audio.loop = kdsNotificationTimer === 1;
        audio.play().catch(err => console.warn('Audio playback failed:', err));
      }
    }

    if (kdsNotification === 1 || kdsNotification === 3) {
      if (kdsNewOrdeMessageType === 0) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: data.message || 'New notification received',
          showConfirmButton: true,
          timer: 10000
        });
      } else if (kdsNewOrdeMessageType === 1) {
        enqueueSnackbar(data.message || 'New notification received', {
          variant: 'success',
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
          autoHideDuration: 10000,
        });
      }
    }
  };

  // Unbind previous handlers before binding new ones
  channel.unbind(ReactSession.get("event_notification"));
  channel.unbind(ReactSession.get("event_online_order"));

  // Bind new handlers with current state
  channel.bind(ReactSession.get("event_notification"), handleNotification);
  channel.bind(ReactSession.get("event_online_order"), handleNotificationNew);

  // Cleanup handlers on dependency change
  return () => {
    if (channelRef.current) {
      channelRef.current.unbind(ReactSession.get("event_notification"));
      channelRef.current.unbind(ReactSession.get("event_online_order"));
    }
  };
}, [currentaudio, kdsNotification, kdsNewOrder, kdsCancelOrder, kdsNewOrdeMessageType, kdsNotificationTimer, getSelectedtags]);

// Cleanup on component unmount
useEffect(() => {
  return () => {
    if (currentaudio) {
      currentaudio.pause();
      setCurrentaudio(null);
      setIsPlaying(false);
    }
    if (channelRef.current) {
      channelRef.current.unbind_all();
      pusherRef.current?.unsubscribe(ReactSession.get("pusher_app_channel"));
      channelRef.current = null;
    }
    if (pusherRef.current) {
      pusherRef.current.disconnect();
      pusherRef.current = null;
    }
    isPusherInitialized.current = false;
  };
}, []);



   
const handlePauseAudio = () => {
  console.log(currentaudio)
  currentaudio.loop = false;
  currentaudio.pause();
  setIsPlaying(false);
};

useEffect(() => {
  //handlePauseAudio();
   //handlePlayPause();
   //console.log(auseAudio)
}, [isPlaying]);


  return (
    <div className="md:mt-1 sm:mt-10">
      {/* {isPlaying && 
      (<Button className="w-px playpusebtn" variant="contained" onClick={handlePauseAudio}>
          Pause 
      </Button>)
      } */}
    
    <div className="">
    {currentTableData.length > 0 ? (  
      // <div className="grid grid-rows-2 grid-flow-col h-screen">
      <div className="grid overflow-hidden grid-cols-4 grid-flow-row-dense justify-items-center items-center">
    {currentTableData.map((item, index) => {
         
         // Find the matching item in the currentItem array
         const matchedItem = currentItem.find(current => current.id === item.id);
         // Check if a matching item is found
         const className = matchedItem ? matchedItem.color : item.defalutcolor;
         const colorNameKey = item.defalutcolorKey;
         const classNameSend  = className;
         const colorclass = matchedItem ? "animate-flicker" : "";
          // Define existing class
         const existingClass = 'shopping__item';
         let isCancelledLabelShown = false
         let isCompletedLabelShown = false;
         let isNewLabelShown = false;
         const getCommaSeperatedIds = () => {
          const ids = item.tableitem.map((item) => item.id);
         
          return ids.join(',');
        };
        
         // Define conditional class className={ j.name == SideMenuCls ? 'sideMenuBarCls shopping__item' : 'shopping__item'}
         
     //style={{ 'background-color': colorNameLate }} ${colorclass}

     
       return (
        <div className="place-self-stretch headercls">
     <Grid item xs={6} md={3} key={item.id} className={className}>
          
        <div className={``} style={{ 
                      pointerEvents: item.kitchen_status == 5 ? 'none' : 'auto',
                      opacity: item.kitchen_status == 5 ? 0.6 : 1 
                    }} >
        {/* <div class="ribbon ribbon-top-left"><span>Completed</span></div> */}
         {/* <div class="ribbon ribbon-top-right"><span>Completed</span></div> */}
         {/* <div class="ribbon ribbon-bottom-left"><span>Completed</span></div> */}
         {item.kitchen_status==5? ( <div class="ribbon ribbon-bottom-right"><span>Completed</span></div>):""}
          <div 
              className={`newcls`}  
              style={{
                'background-color': item.kitchen_status === 5 
                  ? (item.statusColorkey || className) 
                  : className
              }}  
              onClick={() => opensModalC(item.table_name, item, item.tableitem, classNameSend, item.textarea)}
            >
            
             <Grid item xs={12} md={12}>
               <div id='stats' className="">
                 <div className='col left-col'  >
                     <span className="table-cls">{item.table_name} [{item.floor_name}] <span className="delivery-type-cls">{item.delivery_type}  </span> </span>
                     
                     
                     <div className="timeCls"><span className="time-span">{item.formattedTime}</span><span className="name-span">{item.customer !== null ? item.customer.name : ""}</span></div>
                     <div className="nameCls"></div>
                     
                   
                 </div>
                 {(() => {
                      const groupItemsm = item.tableitem.filter(
                        (i) => i.menu_id === SideMenuCls 
                      );
                      
                      if (groupItemsm.length > 0) {
                        return (
                          <div className='col center-col'> <CircleIcon style={{ backgroundColor : "goldenrod"}}  className="text-center"/></div>
                        );
                      }
                      return null;
                    })()} 
                 <div className='col right-col'>
                
                   
                     <Button className="w-px actionbtn" variant="contained"  onClick={(e) => {
                      e.stopPropagation();
                      opensModal(
                        item.order_number,
                        item.id,
                        item.kitchen_status,
                        item.lastDocket,
                        classNameSend,
                        getCommaSeperatedIds,
                        item.is_fos,
                        item.fos_status,
                        item,
                       colorNameKey 
                      );
                    }} >
                      Action 
                     </Button>
                  
                   
                 </div>
               </div>
             </Grid>
             
           </div>
          
           <div className="scroll-div min-h-28 md:min-h-36 lg:min-h-80 xl:min-h-68 max-h-lvh md:max-h-svh lg:max-h-68 xl:max-h-84" key={item.id} >
           
             
           
             <ol className='my-list card-links style-3' ref={scrollContainerRefs[1]}>
            
              {item.tableitem.map((i, j) => (
                (i.kitchen_status == 0 || i.kitchen_status == "0") && (
                  <div key={i.id}>
                    {!isNewLabelShown && (isNewLabelShown = true) && (
                      <li className='shopping__itemh newClss'>
                        <label htmlFor="potatoes" className='shopping__label newCls'>
                          New
                        </label>
                      </li>
                    )}
                    <li
                      className={`${j} shopping__itemh ${i.menu_id === SideMenuCls ? 'sideMenuBarCls' : ''}`}
                      onClick={() => { toggleItemStatus(i.id, i.kitchen_status,item.is_fos); }}
                    >
                      <label
                        htmlFor="potatoes"
                        className='shopping__label'
                        style={{
                          textDecoration: i.completed ? 'line-through' : 'none',
                          textDecorationColor: i.completed ? 'red' : 'inherit',
                        }}
                      >
                        {i.qty} X {i.name} {(i.is_qr == 1) && (<QrCodeScannerIcon />)}
                      </label>
                      {(i.spice_level != null) && (
                          <ol style={{'background-color' : "rgb(215 221 214)" }} className="my-list style-3 underOl">
                          <li className="shopping__item" >
                          <label htmlFor="potatoes" className="shopping__label">
                            Spice Level : { i.spice_level}
                          </label>
                        </li>
                        </ol>  
                      )}
                      {i.token_attributes && (
                        <ol className="my-list style-3 underOl" style={{ display: i.kitchen_status === 6 ? 'none' : 'block' }}>
                          {i.token_attributes.map(j => (
                            <li className="shopping__item" key={j.id}> + {j.name} x{i.qty} </li>
                          ))}
                        </ol>
                      )}
                      {(i.notes != null) && (
                            <ol style={{'background-color' : "rgb(236 231 177)" }} className="my-list style-3 underOl">
                            <li className="shopping__item" >
                            <label htmlFor="potatoes" className="shopping__label" title={ i.notes} >
                              Special Instructions : { i.notes}
                            </label>
                          </li>
                          </ol>
                            
                        )}
                          {(i.textarea != null) && (i.textarea_label != null) && (
                              <ol style={{'background-color' : "rgb(236 231 177)" }} className="my-list style-3 underOl">
                              <li className="shopping__item" >
                              <label htmlFor="potatoes" className="shopping__label">
                              { i.textarea_label}  : { i.textarea}
                              </label>
                            </li>
                            </ol>
                          
                        )}
                    </li>
                  </div>
                )
              ))}
               {item.tableitem.map((i, k) => (
                  (i.kitchen_status == 6 || i.kitchen_status == 5 || i.kitchen_status == "6") && (
                    <div key={i.id}>
                      {!isCompletedLabelShown && (isCompletedLabelShown = true) && (
                        <li className='shopping__itemh completedClss'>
                          <label htmlFor="potatoes" className='shopping__label completedCls'>
                            Completed
                          </label>
                        </li>
                      )}
                      <li
                        className={`${k} shopping__itemh ${i.menu_id === SideMenuCls ? 'sideMenuBarCls' : ''}`}
                        onClick={() => toggleItemStatus(i.id, i.kitchen_status,item.is_fos)}
                        style={{
                          pointerEvents: i.kitchen_status === 3 || i.kitchen_status === 5 ? 'none' : 'auto',
                        }}
                      >
                        <label
                          htmlFor="potatoes"
                          className='shopping__label'
                          style={{
                            textDecoration: i.kitchen_status === 6 || i.kitchen_status === 3 || i.kitchen_status === 5 || i.completed ? 'line-through' : 'none',
                            textDecorationColor: i.kitchen_status === 6 || i.kitchen_status === 3 || i.kitchen_status === 5  || i.completed ? 'red' : 'inherit',
                            pointerEvents: i.kitchen_status === 3 || i.kitchen_status === 5 ? 'none' : 'auto',
                          }}
                        >
                          {i.qty} X {i.name} {(i.is_qr == 1) && (<QrCodeScannerIcon />)}
                        </label>
                        {(i.spice_level != null) && (
                            <ol style={{'background-color' : "rgb(215 221 214)" }} className="my-list style-3 underOl">
                            <li className="shopping__item" >
                            <label htmlFor="potatoes" className="shopping__label">
                              Spice Level : { i.spice_level}
                            </label>
                          </li>
                          </ol>  
                        )}
                        <span className="shopping__span"></span>
                        {i.token_attributes.length !== 0 && (
                          <ol className="my-list style-3 underOl" style={{ display: i.kitchen_status === 6 ? 'none' : 'block' }}>
                            {i.token_attributes.map(j => (
                              <li className="shopping__item" key={j.id}>+ {j.name} x{i.qty} </li>
                            ))}
                          </ol>
                        )}
                        {(i.notes != null) && (
                              <ol style={{'background-color' : "rgb(236 231 177)" }} className="my-list style-3 underOl">
                              <li className="shopping__item" >
                              <label htmlFor="potatoes" className="shopping__label" title={ i.notes}>
                                Special Instructions : { i.notes}
                              </label>
                            </li>
                            </ol>
                             
                          )}
                          {(i.textarea != null) && (i.textarea_label != null) && (
                              <ol style={{'background-color' : "rgb(236 231 177)" }} className="my-list style-3 underOl">
                              <li className="shopping__item" >
                              <label htmlFor="potatoes" className="shopping__label">
                              { i.textarea_label}  : { i.textarea}
                              </label>
                            </li>
                            </ol>
                          
                        )}
                      </li>
                    </div>
                  )
                ))}
               
               {item.tableitem.map((i, l) => {
                    return (
                      (i.kitchen_status === 3) && (
                        <div key={i.id}>
                          {!isCancelledLabelShown && (isCancelledLabelShown = true) && (
                            <li className='shopping__itemh cancelledClss'>
                              <label htmlFor="potatoes" className='text-center shopping__label cancelledCls'>
                                Cancelled
                              </label>
                            </li>
                          )}
                          <li
                            className={`${l} shopping__itemh ${i.menu_id === SideMenuCls ? 'sideMenuBarCls' : ''}`}
                            style={{ pointerEvents: i.kitchen_status === 3 ? 'none' : 'auto' }}
                            onClick={() => { toggleItemStatus(i.id, i.kitchen_status,item.is_fos); }}
                          >
                            <label
                              htmlFor="potatoes"
                              className='shopping__label'
                              style={{
                                textDecoration: i.kitchen_status === 3 || i.completed ? 'line-through' : 'none',
                                textDecorationColor: i.kitchen_status === 3 || i.completed ? 'red' : 'inherit',
                                pointerEvents: i.kitchen_status === 3 ? 'none' : 'auto',
                              }}
                            >
                              {i.qty} X {i.name} {(i.is_qr == 1) && (<QrCodeScannerIcon />)}
                            </label>
                              {(i.spice_level != null) && (
                                 <ol style={{'background-color' : "rgb(215 221 214)" }} className="my-list style-3 underOl">
                                  <li className="shopping__item" >
                                  <label htmlFor="potatoes" className="shopping__label">
                                    Spice Level : { i.spice_level}
                                  </label>
                                </li>
                                </ol>  
                              )}
                            {/* {i.kitchen_status === 3 && <span className="shopping__span"><br />Cancelled</span>} */}
                            {i.token_attributes && (
                              <ol className="my-list style-3 underOl" style={{ display: i.kitchen_status === 6 ? 'none' : 'block' }}>
                                {i.token_attributes.map(j => (
                                  <li className="shopping__item" key={j.id}>+ {j.name} x{i.qty}</li>
                                ))}
                              </ol>
                            )}
                             {(i.notes != null) && (
                              <ol style={{'background-color' : "rgb(236 231 177)" }} className="my-list style-3 underOl">
                              <li className="shopping__item" >
                              <label htmlFor="potatoes" className="shopping__label" title={ i.notes}>
                                Special Instructions : { i.notes}
                              </label>
                            </li>
                            </ol>
                             
                          )}
                          {(i.textarea != null) && (i.textarea_label != null) && (
                              <ol style={{'background-color' : "rgb(236 231 177)" }} className="my-list style-3 underOl">
                              <li className="shopping__item" >
                              <label htmlFor="potatoes" className="shopping__label">
                              { i.textarea_label}  : { i.textarea}
                              </label>
                            </li>
                            </ol>
                          
                        )}
                          </li>
                        </div>
                      )
                    );
                  })}
             </ol>
             
            
             
             <button className="scroll-button up" onClick={() => handleScroll( 1 ,'up')}>
               <ArrowDropUpIcon />
             </button>
             <button className="scroll-button down" onClick={() => handleScroll(1,'down')}>
               <ArrowDropUpIcon />
             </button>
             {/* <button className="scroll-button readmore"  onClick={() => opensModalC(item.table_name , item , item.tableitem)} >
                 <LocalLibrarySharpIcon />
                  
             </button> */}
            
           </div>
           
           
         </div>
     </Grid>
     </div>
     )
    })}
   
<ModalComponentWithOutTags open={modalOpenC} onClose={closeModalC} sendClassModal={sendClassModal}  toggleItemStatus={toggleItemStatus} data={modalDataC} modalTextarea={modalTextarea} allData={modalDataA} listData={modalDataH} updateListData={handleUpdateListData} sendclass="newcls" />
      <ActionComponent currentDocketColor={currentDocketColor}  open={modalOpen} onClose={closeModal}   docketBump={docketBump} AllItemIds={allItemIds} LastDocketStatus = {lastDocketStatus} itemsStatus={itemsStatus} ItemsId={itemsId} data={modalData} sendclass="actioncls" isFos={isFos} fosStatus={fosStatus} itemData={itemData} />
  </div>
   ):(<div className="flex justify-center items-center h-screen">
       <div className="empty-state">
       
  <div className="empty-state__content">
  <div className="empty-state__message">{screenName}</div>
    <div className="empty-state__icon">
      <img src="data:image/png;base64,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" alt=""/>
    </div>
    <div className="empty-state__message">No records has been found.</div>
    
  </div>
</div></div>)}
      
         
     
      

      
    </div>

    </div>
  )
}

export default OrderListWhitOutTags